import Breadcrumbs from '../../components/Breadcrumbs';
import '../../styles/Access.css';
import Users from './Users';

const Access = () => {
    return (
        <div>
            <Breadcrumbs values={['Access Management', 'Users']} />

            <div className='access_view'>
                <h2>Users</h2>
            </div>

            <Users />
        </div>
    )
}

export default Access